import React from 'react';
import './NavMenu.css';
import NavMenuItem from '../NavMenuItem/NavMenuItem';
import Flex from '../Flex/Flex';
import FAQIcon from '../../assets/Icons/FAQIcon.svg?react';
// import MiningIcon from "../../assets/Icons/MiningIcon.svg?react";
import TopPlayersIcon from '../../assets/Icons/TopPlayersIcon.svg?react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DollarOutlined, GiftOutlined } from '@ant-design/icons';

const NavMenu = React.memo(() => {
  const { t } = useTranslation('translation');
  const location = useLocation();
  const { pathname } = location;

  const menuItems = React.useMemo(
    () => [
      {
        label: t('referral'),
        icon: <GiftOutlined />,
        link: '/referral',
        isDisabled: false,
      },
      { label: 'FAQ', icon: <FAQIcon />, link: '/faq', isDisabled: false },
      // {
      //   label: t("mining"),
      //   icon: <MiningIcon />,
      //   link: "/mining",
      //   isDisabled: true,
      // },
      {
        label: t('subscription'),
        icon: <DollarOutlined />,
        link: '/subscription',
      },
      {
        label: t('top_players'),
        icon: <TopPlayersIcon />,
        link: '/top-players',
      },
    ],
    [t],
  );

  return (
    <Flex className="NavMenu" gap={0}>
      {menuItems.map((x) => (
        <NavMenuItem
          key={x.label}
          label={x.label}
          link={x.link}
          isActive={pathname === x.link}
          isDisabled={x.isDisabled}
          icon={x.icon}
        />
      ))}
    </Flex>
  );
});

export default NavMenu;
